type Props = {};

const PageNotFound = (props: Props) => {
  return <div>PageNotFound</div>;
};

export default PageNotFound;
